"use client"
import Footer from "@/components/UI/footer/footer"
import Topbar from "@/components/UI/navbar/topbar"
import Image from "next/image"
import PersonInfo from "@/components/about/PersonInfo"
import CarouselData from "@/content/rules.json" assert { type: "json" }
import persononsData from "@/content/persons.json"
import HeroSection from "@/components/hero"
import ContentElement from "@/components/UI/ContentElement/ContentElement"
import CarouselElement from "@/components/about/carousel/carousel"
import MentionsElement from "@/components/mentions";
import {SEOUtil} from "@/utils/SEOUtil";

export default function About() {
    return (
        <>
            <SEOUtil name="O nas" url="/about" description="Dowiedz się więcej o naszym zespole i naszej misji." mainEntityOfPage page />
            <Topbar />
            <main>
                <HeroSection
                    src={"/about/baner-about.webp"}
                    heading={"Trochę o nas,"}
                    other={{ italic: "czyli jak zmieniamy przyszłość edukacji." }}
                    className='mb-0'
                />

                <ContentElement
                    className="p-10 md:p-20 text-center text-white mt-0 mb-20"
                    heading="Programy partnerskie i mentorskie"
                    subheading="Poznaj nasze inicjatywy">
                    <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-14 lg:gap-16 max-w-480 mx-auto">
                        <div className="flex-1 bg-sectionbg p-8 md:p-16 lg:p-18 xl:p-20 rounded-2xl md:rounded-3xl shadow-lg hover:shadow-xl transition-shadow">
                            <Image
                                src="/about/programs/kierunek-dobra-robota.png"
                                alt="Program partnerski - Kierunek: Dobra Robota!"
                                width={1168}
                                height={436}
                                className="rounded-2xl md:rounded-3xl w-full h-auto object-cover object-center md:scale-[1.06] lg:scale-[1.08] xl:scale-[1.10] transition-transform"
                            />
                        </div>

                        <div className="flex-1 bg-sectionbg p-8 md:p-16 lg:p-18 xl:p-20 rounded-2xl md:rounded-3xl shadow-lg hover:shadow-xl transition-shadow">
                            <Image
                                src="/about/programs/krok-do-przodu.png"
                                alt="Program mentorski - Krok do przodu"
                                width={1168}
                                height={436}
                                className="rounded-2xl md:rounded-3xl w-full h-auto object-cover object-center md:scale-[1.06] lg:scale-[1.08] xl:scale-[1.10] transition-transform"
                            />
                        </div>

                        <div className="flex-1 bg-sectionbg p-8 md:p-16 lg:p-18 xl:p-20 rounded-2xl md:rounded-3xl shadow-lg hover:shadow-xl transition-shadow">
                            <Image
                                src="/about/programs/masz-wplyw.png"
                                alt="Program partnerski - Masz wpływ!"
                                width={1168}
                                height={436}
                                className="rounded-2xl md:rounded-3xl w-full h-auto object-cover object-center md:scale-[1.06] lg:scale-[1.08] xl:scale-[1.10] transition-transform"
                            />
                        </div>
                    </div>
                </ContentElement>

                <MentionsElement />

                <ContentElement
                    className='p-20 m-0 text-center mb-40'
                    heading='Nasze zasady i wartości'
                    subheading='Czym się kierujemy'>
                    <CarouselElement data={CarouselData} />
                </ContentElement>
                <ContentElement
                    heading={
                        "Jesteśmy młodym, dynamicznie rozwijającym się zespołem, któremu przyświeca jeden cel - niesienie naszej wizji na zmianę w polskim pojmowaniu edukacji"
                    }
                    className='text-center bg-sectionbg flex flex-col gap-12 mb-36 py-48 px-0'
                    subheading={"Nasza wizja"}
                    isWhite={true}>
                    <div className='overflow-hidden w-full'>
                        <Image
                            src='/about/zespol.webp'
                            alt='Zespol'
                            width={2000}
                            height={100}
                            className='rounded-[30px] my-0 mx-auto w-auto h-200'
                        />
                    </div>
                </ContentElement>
                <ContentElement
                    className='p-28 relative'
                    heading={
                        "Nasz zespół to grupa wyjątkowych profesjonalistów, wyróżniających się pasją i zaangażowaniem"
                    }
                    subheading={"Nasz Zespół"}>
                    <div className='mx-auto container grid xl:grid-cols-4 grid-cols-2 justify-stretch gap-10'>
                        {persononsData.map((item, index) => {
                            return (
                                <PersonInfo
                                    key={index}
                                    url={item.url}
                                    name={item.name}
                                    lastname={item.lastname}
                                    role={item.role}
                                    date={item.date}
                                />
                            );
                        })}
                    </div>
                </ContentElement>
            </main>
            <Footer />
        </>
    )
}
